import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  fill: "none",
  viewBox: "0 0 40 40"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "square",
      "stroke-miterlimit": "10",
      d: "M20 38.75c10.355 0 18.75-8.395 18.75-18.75S30.355 1.25 20 1.25 1.25 9.645 1.25 20 9.645 38.75 20 38.75Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M15 28.75v-17.5L28.75 20z"
    }, null, -1)
  ]))]))
}
export default { render: render }